var _path, _path2, _circle, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoWorkActivity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1718 27.9948H18.0035C15.016 27.9948 13.5227 27.9948 12.5943 27.049C11.666 26.1031 11.666 24.5806 11.666 21.5365C11.666 18.4923 11.666 16.9698 12.5943 16.024C13.5227 15.0781 15.016 15.0781 18.0035 15.0781H21.1727C24.1602 15.0781 25.6543 15.0781 26.5827 16.024C27.2968 16.7515 27.461 17.8206 27.4993 19.6615",
    stroke: "#7663EB",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.707 26.2057L24.582 25.4557V23.5807M23.332 15.0807L23.2487 14.8224C22.837 13.5391 22.6304 12.8974 22.1395 12.5307C21.6479 12.1641 20.9962 12.1641 19.692 12.1641H19.472C18.1679 12.1641 17.5154 12.1641 17.0245 12.5307C16.5329 12.8974 16.327 13.5391 15.9145 14.8224L15.832 15.0807M20.832 25.0807C20.832 25.5732 20.929 26.0608 21.1175 26.5158C21.3059 26.9708 21.5822 27.3842 21.9304 27.7324C22.2786 28.0806 22.692 28.3568 23.147 28.5453C23.6019 28.7337 24.0896 28.8307 24.582 28.8307C25.0745 28.8307 25.5621 28.7337 26.0171 28.5453C26.4721 28.3568 26.8855 28.0806 27.2337 27.7324C27.5819 27.3842 27.8581 26.9708 28.0466 26.5158C28.235 26.0608 28.332 25.5732 28.332 25.0807C28.332 24.0862 27.9369 23.1323 27.2337 22.4291C26.5304 21.7258 25.5766 21.3307 24.582 21.3307C23.5875 21.3307 22.6336 21.7258 21.9304 22.4291C21.2271 23.1323 20.832 24.0862 20.832 25.0807Z",
    stroke: "#7663EB",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.25,
    cy: 20.5,
    r: 19,
    stroke: "#7663EB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 34L33.75 7",
    stroke: "#7663EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoWorkActivity);
export default __webpack_public_path__ + "static/media/no-work-activity.6e763f57582ca56c649d8eede1885bc0.svg";
export { ForwardRef as ReactComponent };